import {
  Component,
  OnChanges,
  Input,
  SimpleChanges,
  OnInit,
  EventEmitter,
  Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

interface DataTableColumn {
  key: string;
  label: string;
  order: string;
  type: string;
  buttons: any[];
}

@Component({
  selector: 'custom-data-table',
  templateUrl: './custom-data-table.component.html',
  styleUrls: ['./custom-data-table.component.scss'],
})
export class CustomDataTableComponent implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute) {
    this.pageSize = this.defaultPageSize;
    this.totalItems = this.data.length;
  }
  @Input() data: any[] = [];
  @Input() columns: DataTableColumn[] = [];
  @Input() pageSizeOptions: number[] = [5, 10, 20];
  @Input() defaultPageSize: number = 10;
  @Input() showSearchColumn: boolean = true;

  @Output() loadMore = new EventEmitter<void>();
  @Output() buttonsOutput = new EventEmitter<any>();
  debounceTimer: any = null;
  time: any;
  displayedData: any[] = [];
  searchQuery: string = '';
  currentPage: number = 0;
  pageSize: number;
  totalItems: number;
  noDataFound = true;

  ngOnInit(): void {
    this.enhanceData();

    this.updateDisplayedData();
    this.setInitialData();
  }

  enhanceData() {
    // adding a order key to each column
    if (this.columns.length) {
      this.columns.forEach((column) => {
        column.order = '';
      });
    }
    // changing the data type to date and number as per the column field
    if (this.data.length) {
      this.noDataFound = false;
      this.data.forEach((item) => {
        this.columns.forEach((column) => {
          if (column.type === 'date') {
            item[column.key] = new Date(item[column.key]);
          } else if (column.type === 'number') {
            item[column.key] = parseFloat(item[column.key]);
          }
        });
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.noDataFound = true;
      console.log('change detected');
      this.updateDisplayedData();
    }
  }

  updateDisplayedData(): void {
    let filteredData = this.data.filter((item) =>
      Object.values(item).some((val: any) =>
        val.toString().toLowerCase().includes(this.searchQuery.toLowerCase())
      )
    );

    const start = this.currentPage * parseInt(this.pageSize.toString());
    const end = start + parseInt(this.pageSize.toString());

    this.displayedData = filteredData.slice(start, end);
    if (this.displayedData.length > 0) this.noDataFound = false;
  }

  applyFilter(): void {
    const filterValue = this.searchQuery || '';

    this.searchQuery = filterValue.trim().toLowerCase();
    this.currentPage = 0;
    this.updateDisplayedData();
    this.onSearchChange();
  }
  onSearchChange() {
    clearTimeout(this.time);
    this.time = setTimeout(() => {
      this.setQueryParams('search', this.searchQuery);
    }, 1000);
  }

  setInitialData() {
    this.searchQuery = this.route.snapshot.queryParams.search || '';

    if (this.searchQuery) {
      this.applyFilter(); // Directly searchQuery ko use karo
    }
  }

  setQueryParams(item: string, value: string | number): void {
    console.log({ item, value });

    let currentParams = {
      ...this.router.routerState.snapshot.root.queryParams,
    };
    if (value === '' || value == -1 || value === null || value === undefined) {
      delete currentParams[item];
    } else {
      currentParams[item] = value;
    }
    this.router.navigate([], {
      queryParams: currentParams,
    });
  }

  sortData(key: string, order: string): void {
    console.log({ key, order });
    if (order === 'desc' || order === '') {
      this.data.sort((a, b) => {
        if (a[key] < b[key]) return -1;
        if (a[key] > b[key]) return 1;
        return 0;
      });
    } else if (order === 'asc') {
      this.data.sort((a, b) => {
        if (a[key] > b[key]) return -1;
        if (a[key] < b[key]) return 1;
        return 0;
      });
    }
    this.columns.forEach((column) => {
      if (column.key === key) {
        column.order = order === 'asc' ? 'desc' : 'asc';
      } else {
        column.order = '';
      }
    });
    this.updateDisplayedData();
  }

  changePageSize(event: any): void {
    this.pageSize = event.target.value;
    this.currentPage = 0;
    this.updateDisplayedData();
  }

  goToPage(page: number): void {
    this.currentPage = Math.ceil(page);
    this.updateDisplayedData();
  }

  buttonsClick(row: any, identifier: string): void {
    this.buttonsOutput.emit({ row, identifier });
  }

  loadMoreData(): void {
    this.loadMore.emit();
  }
}
